"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * 判断是否是window
 * @member util
 */
function isWindow(obj) {
  return obj !== null && obj !== undefined && obj === obj.window;
}
function getClientPosition(elem) {
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  var box = elem.getBoundingClientRect();
  /*
   * 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
   * 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
   * 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
   */
  x = box.left;
  y = box.top;
  /*
   * In IE, most of the time, 2 extra pixels are added to the top and left
   * due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
   * IE6 standards mode, this border can be overridden by setting the
   * document element's border to zero -- thus, we cannot rely on the
   * offset always being 2 pixels.
   */
  /*
   * In quirks mode, the offset can be determined by querying the body's
   * clientLeft/clientTop, but in standards mode, it is found by querying
   * the document element's clientLeft/clientTop.  Since we already called
   * getClientBoundingRect we have already forced a reflow, so it is not
   * too expensive just to query them all.
   */
  /*
   * ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
   * 窗口边框标准是设 documentElement ,quirks 时设置 body
   * 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
   * 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
   * 标准 ie 下 docElem.clientTop 就是 border-top
   * ie7 html 即窗口边框改变不了。永远为 2
   * 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
   */
  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}
function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}
function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}
// dom工具方法
var domUtils = {};
each(['Width', 'Height'], function (name) {
  // 获取文档document的宽高： docWidth docHeight
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    /*
     * firefox chrome documentElement.scrollHeight< body.scrollHeight
     * ie standard mode : documentElement.scrollHeight> body.scrollHeight
     */
    d.documentElement["scroll".concat(name)],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](refWin));
  };
  // 获取视口window的宽高： viewportWidth viewportHeight
  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    /*
     * 标准模式取 documentElement
     * backcompat 取 body
     */
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/**
 * 获取元素的top left
 * @param el
 * @returns {{top, left}}
 */
function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  pos.top += getScroll(w, true);
  return pos;
}
/**
 * 得到元素的width or height 信息
 *
 * @param elem
 * @param name
 * @returns {*|number}
 */
function getWH(elem, name) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  }
  if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(window) : domUtils.docHeight(window);
  }
  return name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
}
var utils = {
  getOffset: getOffset,
  getWH: getWH
};
var _default = exports.default = utils;